import { PART_PRICE } from '../../constants';
import { formatCurrency } from '../../helpers/formatCurrency';
import { getProductLabels } from '../../helpers/getProductLabels';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { MIN_QUANTITY, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CartLineItem: FunctionComponent<Props> = ({
    className = '',
    line,
    onDecrement,
    onIncrement,
    onRemove,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const lineTotal = PART_PRICE[line.partId] * line.qty;
    const isAtMinimum = line.qty <= MIN_QUANTITY;
    const decrementClass = isAtMinimum ? styles.isDisabled : '';

    const handleDecrement = () => {
        if (isAtMinimum) {
            return;
        }
        onDecrement(line.partId);
    };

    return (
        <VerticalContainer className={`${styles.cartLine} ${className}`} testId={testId}>
            <HorizontalContainer className={styles.cartLineHead}>
                <Wrapper className={styles.cartLineName}>
                    {getProductLabels(t)[line.partId]}
                </Wrapper>

                <Wrapper className={styles.cartLineTotal}>{formatCurrency(lineTotal)}</Wrapper>
            </HorizontalContainer>

            <HorizontalContainer className={styles.cartLineControls}>
                <HorizontalContainer className={styles.qtyStepper}>
                    <Wrapper
                        className={`${styles.qtyButton} ${decrementClass}`}
                        onClick={handleDecrement}>
                        –
                    </Wrapper>

                    <Wrapper className={styles.qtyValue}>{`${line.qty}`}</Wrapper>

                    <Wrapper className={styles.qtyButton} onClick={() => onIncrement(line.partId)}>
                        +
                    </Wrapper>
                </HorizontalContainer>

                <Wrapper className={styles.cartLineRemove} onClick={() => onRemove(line.partId)}>
                    {t.REMOVE}
                </Wrapper>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default CartLineItem;
